import React from 'react'

const TextArea = (props) => {
    return (
        <textarea className="scroll bounded-textarea" type="text" name="content" onChange={(e) => {props.setHandler(e.target.value)}} placeholder={props.placeholderText}></textarea>
    )
}

export default TextArea